import { get, post, postChange } from './index'

export const list = params => {
  return get('/api/bonoch_role/list', params)
}
export const editGet =(params)=> {
  return postChange('/api/bonoch_role/edit?id='+params.id, params,'get')
}
export const editPost =(params)=> {
  return postChange('/api/bonoch_role/edit?id='+params.id, params,'post')
}

export const tree = params => {
  return get('/api/bonoch_role/tree', params)
}

export const authTree = params => {
  return get('/api/bonoch_role/auth_tree', params)
}

export const add = params => {
  return post('/api/bonoch_role/add', params)
}

export const del = params => {
  return post('/api/bonoch_role/del', params)
}

export const system = params => {
  return get('api/rampow/admin/system', params)
}

